const suggestions = [
	{ name: '2-Ethylhexanol' },
	{ name: '2-Ethylhexanoic Acid' },
	{ name: '5 ways to upgrade feed' },
	{ name: 'Adhesives' },
	{ name: 'BioPlastics' },
	{ name: 'Biodegradable plastic with Capa' },
	{ name: 'Albin, SPPO Plant' },
	{ name: 'Benchmark for non-phthalate plasticizers' },
	{ name: 'BioPlastics: The Re-Invention of Plastics via Renewable Chemicals 2015' },
	{ name: 'Glycerine tech' },
	{ name: 'Neopentyl Glycol molten' },
	{ name: 'Molds and mycotoxins' },
	{ name: 'New ProMyr website launched' },
	{ name: 'Metalworking fluids' },
	{ name: 'Perstorp acquires TallOil' },
	{ name: 'Chaitali Danave' },
	{ name: 'Natalia Sapranova' },
];

const emulatedNetworkDelay = 1500;

export function searchTypeaheadTest() {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve(
				suggestions.map(s => ({
					name: s.name
				}))
			);
		}, emulatedNetworkDelay);
	});
}
